<script>
  import ValidationMessage from '../../../components/form/ValidationMessage.vue'
  import BackButton from '../../../components/general/BackButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import bus from '@utils/bus'
  import {requiredIf} from 'vuelidate/lib/validators'

  export default {
    components: {ValidationMessage, BackButton},
    props: {
      model: {
        default: function () {
          return {}
        },
        type: Object
      }
    },
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        evaluationFinished: false,
        averageLower: true,
        paper: {},
        review: {last_action: {status: {key: ''}}, notes: ''},
        paperReviewId: '',
        evaluations: []
      }
    },
    validations: function () {
      return {
        review: {
          notes: {
            required: requiredIf(function () {
              return this.averageLower
            })
          }
        }
      }
    },
    computed: {
      idAccepted: function () {
        return this.review.last_action.status.key === 'aceito' || this.review.last_action.status.key === 'em_avaliacao' || this.review.last_action.status.key === 'avaliado'
      },
      evaluationAverageForm: function () {
        let average = 0
        if (this.evaluations.length > 0) {
          let totalEvaluation = 0
          this.evaluations.forEach(item => {
            totalEvaluation += item.value
          })
          average = (totalEvaluation / this.evaluations.length).toFixed(2)
        }
        this.averageLower = average < this.review.event_paper_type_evaluation_type.min_evaluation_next_step
        return average
      },
      evaluationAverageResponse: function () {
        if (this.review.responses.length > 0) {
          let average = 0
          let totalResponses = 0
          this.review.responses.forEach((item) => {
            if (item.evaluation_type_criteria.criteria.type === 'number') {
              average += parseFloat(item.value)
              totalResponses++
            }
          })
          if (totalResponses > 0) {
            return (average / totalResponses).toFixed(2)
          } else {
            return 0
          }
        } else {
          return 0
        }
      },
      getReviewFilePath: function () {
        return this.review.paper.file ? this.review.paper.file.show_file_path : null
      },
      getReviewDownloadFilePath: function () {
        return this.review.paper.file ? this.review.paper.file.download_file_path : null
      },
      isEvaluationInLoco: function () {
        return this.review.event_paper_type_evaluation_type.evaluation_type_id === 2
      }
    },
    mounted () {
      bus.$emit('show-loader')
      const id = this.$route.params.id
      this.getReview(id)
    },
    methods: {
      getReview (id) {
        restfulService.get('paper_review', null, id)
          .then((response) => {
            if (response.last_action.status.key === 'avaliado' && response.responses.length > 0) {
              this.evaluationFinished = true
            } else {
              this.evaluations.splice(0)
              if (response.responses.length === 0 && response.event_paper_type_evaluation_type.evaluation_opened) {
                response.event_paper_type_evaluation_type.criterias.forEach((item) => {
                  if (item.criteria.type === 'number') {
                    item.value = 10
                  } else {
                    item.value = ''
                  }
                  this.evaluations.push({
                    id: item.id,
                    name: item.criteria.name,
                    type: item.criteria.type,
                    min_size: item.criteria.min_size,
                    max_size: item.criteria.max_size,
                    value: item.value
                  })
                })
              }
            }
            this.review = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isLoadingData = false
            this.$router.push({name: 'home'})
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      onAcceptPaper () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = {}
        restfulService.put('paper_review', 'appraiser-accept', this.review.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.getReview(this.review.id)
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      onRejectPaper () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = {}
        restfulService.put('paper_review', 'appraiser-reject', this.review.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'evaluation.index', params: {status: 'assigned'}})
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      onSaveEvaluation () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = {
          paper_review_id: this.review.id,
          evaluations: this.evaluations,
          notes: this.review.notes,
          reproved: this.averageLower
        }
        restfulService.put('paper_review', 'save-criterias', this.review.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.getReview(this.review.id)
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
            bus.$emit('hide-loader')
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData" class="custom-list" id="paper-content">
        <h2 class="flex-header">
            <span>Visualizando os dados da Trabalho #{{review.paper.id}}</span>
            <back-button/>
        </h2>
        <div v-if="idAccepted && !isEvaluationInLoco">
            <object :data="getReviewFilePath"
                    type="application/pdf">
                <embed :src="getReviewFilePath"
                       type="application/pdf"/>
            </object>
        </div>
        <div class="download-file" v-if="!isEvaluationInLoco">
            Caso não esteja visualizando o PDF do trabalho, clique no botão ao lado para baixar o arquivo
            <a :href="getReviewDownloadFilePath" target="_blank" class="el-button el-button--primary">
                <i class="far fa-file-pdf"></i>
                <span>Download do Arquivo</span>
            </a>
        </div>
        <el-row :gutter="20">
            <el-col :span="12">
                <table class="table-confirmation">
                    <thead>
                    <tr>
                        <th colspan="2">Informações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="review.paper.knowledge_area">
                        <td>
                            <strong>Área do Conhecimento:</strong> {{review.paper.knowledge_area.full_name}}
                        </td>
                    </tr>
                    <tr v-for="content in review.paper.contents">
                        <td v-if="content.event_paper_type_field.field.type !== 'file' && content.event_paper_type_field.field.key !== 'link_plataforma_lattes_10_200'">
                            <strong>{{content.event_paper_type_field.field.name}}:</strong> {{content.value}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
            <el-col :span="12">
                <table class="table-confirmation" v-if="idAccepted">
                    <thead>
                    <tr>
                        <th colspan="2">Avaliação do trabalho</th>
                    </tr>
                    </thead>
                    <tbody v-if="!evaluationFinished">
                    <tr v-if="evaluations.length">
                        <td colspan="2">
                            <el-form ref="formEvaluation" label-position="top">
                                <table class="table-evaluations">
                                    <tbody>
                                    <tr v-for="item in evaluations">
                                        <td colspan="2">
                                            <el-form-item class="input-evaluations" :label="item.name">
                                                <div class="block">
                                                    <el-slider v-model="item.value"
                                                               :min="item.min_size"
                                                               :step="0.1"
                                                               :max="item.max_size"
                                                               show-input/>
                                                </div>
                                            </el-form-item>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">Média</td>
                                        <td>
                                            <el-form-item v-bind:class="{'el-form-item--error': averageLower}">
                                                <el-input v-model="evaluationAverageForm"
                                                          readonly/>
                                                <div v-if="averageLower" class="el-form-item__error">
                                                    A nota mínima para aprovação é
                                                    <strong>{{review.event_paper_type_evaluation_type.min_evaluation_next_step}}</strong>,
                                                    caso o trabalho esteja abaixo dessa nota você precisa justificar a
                                                    reprovação.
                                                </div>
                                            </el-form-item>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right">Justificativa/Observações</td>
                                        <td>
                                            <el-form-item
                                                    v-bind:class="{'is-required': averageLower, 'el-form-item--error': averageLower && !review.notes}">
                                                <el-input type="textarea"
                                                          v-model="review.notes"
                                                          :rows="4"
                                                          :maxlength="300"/>
                                                <div v-if="averageLower && !review.notes" class="el-form-item__error">
                                                    Você precisa justificar a reprovação.
                                                </div>
                                            </el-form-item>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="right"></td>
                                        <td>
                                            <el-form-item>
                                                <el-button type="success"
                                                           @click="onSaveEvaluation"
                                                           :disabled="isSubmitted || (averageLower && !review.notes)">
                                                    <i class="fa fa-check"></i>
                                                    <span>Salvar Avaliação</span>
                                                </el-button>
                                            </el-form-item>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </el-form>
                        </td>
                    </tr>
                    <tr v-if="evaluations.length === 0">
                        <td>Nenhum critério de avaliação encontrado, entre em contato com o administrador.</td>
                    </tr>
                    </tbody>
                    <tbody v-if="evaluationFinished">
                    <tr v-for="item in review.responses">
                        <td width="50%" align="right">
                            <strong>{{item.evaluation_type_criteria.criteria.name}}:</strong>
                        </td>
                        <td>{{item.value}}</td>
                    </tr>
                    <tr>
                        <td align="right"><strong>Média:</strong></td>
                        <td>{{evaluationAverageResponse}}</td>
                    </tr>
                    </tbody>
                </table>
                <table class="table-confirmation" v-if="!idAccepted">
                    <thead>
                    <tr>
                        <th>Avaliação do trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td v-if="review.event_paper_type_evaluation_type.evaluation_opened && !review.event_paper_type_evaluation_type.evaluation_finished">
                            <el-button type="success"
                                       @click="onAcceptPaper"
                                       :disabled="isSubmitted">
                                <i class="fa fa-check"></i>
                                <span>Aceitar Trabalho</span>
                            </el-button>
                            <el-button type="danger"
                                       @click="onRejectPaper"
                                       :disabled="isSubmitted">
                                <i class="fa fa-times"></i>
                                <span>Rejeitar Trabalho</span>
                            </el-button>
                        </td>
                        <td v-if="review.event_paper_type_evaluation_type.evaluation_finished" align="center">
                            <el-tag type="danger">Prazo de Avaliação Finalizado</el-tag>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
        </el-row>
    </div>
</template>

<style lang="scss">
    #paper-content {
        object,
        embed {
            width: 100%;
            height: 700px;
        }
        object {
            border: 1px solid #CCC;
            margin-bottom: 20px;
        }
    }

    .download-file {
        padding-bottom: 15px;
    }

    .table-evaluations {
        border-collapse: collapse;
        width: 100%;
    }

    .input-evaluations .el-input-number {
        width: 130px;
    }
</style>
